import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/langivare/$slug")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/privatlan/$slug", params: { slug: params.slug }, statusCode: 301 });
  },
});
